import { Placeholder, ToolbarGroup } from '@wordpress/components';
import { useBlockProps, BlockControls } from '@wordpress/block-editor';
import Inspector from './inspector';

export const edit = ( props ) => {
    const { attributes, setAttributes } = props;
    const blockProps = useBlockProps();

    return (
        <div {...blockProps}>
            <BlockControls>
                <ToolbarGroup />
            </BlockControls>

            <div className="realpress-price-property" style={{padding: "20px"}}>
                <i style={{color: attributes.color}}>Price property</i>
            </div>

            <Inspector attributes={attributes} setAttributes={setAttributes} />
        </div>
    );
}

